export const CAROUSEL_HERO_IMAGE_CONSTANTS = {
    animations: {
        imagesMotionDuration: 500,
        progressBarDuration: 5000
    },
    defaultControlsPosition: '20px',
    defaultTitleLineHeight: '32px',
    defaultTitleSize: '24px'
};
